import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import * as fromActions from './schedule-dashboard.action';
import * as fromAdapter from './schedule-dashboard.adapter';
import { Observable, of } from "rxjs";
import { AvailabilityService } from "../../shared/services/availability.service";
import { IAvailability, IScheduleAvailability } from "@signal/asp-data-commons/lib/interfaces/availability";
import { Department, IAppointment, IAppointmentSummary, IResponse } from "@signal/asp-data-commons";
import { catchError, map, mergeMap } from "rxjs/operators";
import { AlertService } from "../../shared/services/alert.service";
import { AppointmentService } from "../../shared/services/appointment.service";
import { GLOBAL_CONSTANT, getAlertErrorMessage } from "../../shared/services/util.service";



@Injectable()
export class ScheduleDashboardEffects {
  
    
    loadScheduleDashboardSlot: Observable<Action> = createEffect(() =>  this.actions$.pipe(
        ofType<fromActions.LoadScheduleDashboardSlot>(
          fromActions.ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_SLOT
        ),
        mergeMap((action: fromActions.LoadScheduleDashboardSlot) =>
          this.availabilityService.getScheduleDashboardSlot(action.payload.department, action.payload.startDate, action.payload.endDate).pipe(
            map((scheduleDashboardSlot: IResponse<IAvailability>) =>
              new fromActions.LoadScheduleDashboardSlotSuccess({
                department: action.payload.department,
                availabilityData: scheduleDashboardSlot.data
              })),
            catchError(err => {
              this.alertService.showAlert(getAlertErrorMessage(err, GLOBAL_CONSTANT.errorMessage));
              return of(new fromActions.LoadScheduleDashboardSlotFailure({error: err, department: action.payload.department}));
            })
          )
        )
      ));

      
      updateAppointmentTimeSlot: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.UpdateAppointmentTime>(
          fromActions.ScheduleDashboardActionTypes.UPDATE_APPOINTMENT_TIME
        ),
        mergeMap((action: fromActions.UpdateAppointmentTime) => 
          this.appointmentService.updateTimeSlot(fromAdapter.updateTimeSlot(action.payload.appointment, action.payload.newTimeSlot)).pipe(
            map((appointmentResp: IAppointment) => 
              new fromActions.UpdateAppointmentTimeSuccess({
                appointment: appointmentResp
              })),
              catchError(err => {
                this.alertService.showAlert(getAlertErrorMessage(err, GLOBAL_CONSTANT.errorMessage));
                return of(new fromActions.UpdateAppointmentTimeFailure({error: err}));
              })
          ))
      ))

      
      loadScheduleDashboardAppointment: Observable<Action> = createEffect(() =>  this.actions$.pipe(
          ofType<fromActions.LoadScheduleDashboardAppointments>(
            fromActions.ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS, fromActions.ScheduleDashboardActionTypes.LOAD_SCHEDULE_DASHBOARD_APPOINTMENTS_REFRESH
          ),
          mergeMap((action: fromActions.LoadScheduleDashboardAppointments) =>
            this.appointmentService.getAppointmentSummary(action.payload.department, action.payload.startDate, action.payload.endDate, action.payload.filters, action.payload.viewMode).pipe(
              map((appointmentSummary: IResponse<IAppointmentSummary[]>) =>
                new fromActions.LoadScheduleDashboardAppointmentsSuccess({
                  department: action.payload.department,
                  appointmentSummary: appointmentSummary.data
                })),
              catchError(err => {
                this.alertService.showAlert(getAlertErrorMessage(err, GLOBAL_CONSTANT.errorMessage));
                return of(new fromActions.LoadScheduleDashboardAppointmentsFailure({error: err, department: action.payload.department}));
              })
            )
          )
        ));

      constructor(private availabilityService: AvailabilityService, private appointmentService: AppointmentService, private actions$: Actions,private alertService: AlertService){}
}